export default "__VITE_ASSET__bp3uTqAW__"